

const hexToRgb = require('./toRgb');
const rgbToHex = require('../rgb/toHex');
const blendPartial = require('../internal/blendPartial');

module.exports = (from, to, percent) => {

  percent = Math.abs(percent) / 100;

  let rgb = hexToRgb(from);
  let rgbBlend = hexToRgb(to);

  let final = {
    'red': blendPartial(rgb.red, rgbBlend.red, percent),
    'green': blendPartial(rgb.green, rgbBlend.green, percent),
    'blue': blendPartial(rgb.blue, rgbBlend.blue, percent)
  };

  return `#${rgbToHex(final)}`;
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/blend.js